<template>
    <Header ueberschrift="Vegetationsbrände" />
    <div id="waldbrand">
        <h2>Infos Vegetationsbrände</h2>
        <a href="https://www.feuerwehr-lernbar.bayern/topics/vegbbk" target="_blank">Infos Vegetationsbrände</a>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Waldbrand',
    components: {
        Header,
        Footer
    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
#waldbrand{
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;
}
</style>